

import './App.css';
import { useEffect,useState } from 'react';
import { Unauthorized } from './components/unauthorized';
import { Authorized } from './components/authorized';
import { Authorize } from './components/authorize';
import { Admin } from './components/admin';
import { WaitTimeStatus } from './components/waitTimeListing';
import { ReservationForm } from './components/reservations';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Cookies from 'js-cookie';
import { MyReservations } from './components/myReservations';
import { BigBoard } from './components/bigBoard';
import { TitleBar } from './components/appBar';
import { SpeakerReservation } from './components/speakerReservation';
function App() {
  
  const [authorized,setAuthorized] = useState(false);

  useEffect(()=>{
    document.title="Jamboree Adventure Programs"
    const authKey = Cookies.get("nsj_access");
    if (authKey){
      setAuthorized(true);
    }
  },[])
  return (
    <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={authorized?<Authorized></Authorized>:<Unauthorized></Unauthorized>}/>
        {/* <Route path="/admin" element={authorized?<Admin></Admin>:<Unauthorized></Unauthorized>}/> */}
        <Route path="/authorize" element={<Authorize></Authorize>}/>
        <Route path="/waittimes" element={<WaitTimeStatus></WaitTimeStatus>}/>
        {/* Unsecured link for activity reservation form */}
        <Route path="/reserve" element={<ReservationForm></ReservationForm>}/>
        <Route path="/speakers" element={<SpeakerReservation></SpeakerReservation>}/>
        {/* Unsecured link for checking participant prending reservations */}
        <Route path="/myreservations" element={<MyReservations></MyReservations>}/>
        {/* Unsecured link for area status display */}
        <Route path="/bigboard" element={
            <>
              <TitleBar title={"Program Status"}></TitleBar>
              <BigBoard></BigBoard>
            </>
          }/>   
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
